import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const PollResultByGroupId = (id, time, groupId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.POLL_RESULT_BY_GROUP_ID(id, time, groupId)
  );
};

export default PollResultByGroupId;
